import { render, staticRenderFns } from "./SupplierPurchaseOrderList.vue?vue&type=template&id=4431a399&scoped=true&"
import script from "./SupplierPurchaseOrderList.vue?vue&type=script&lang=js&"
export * from "./SupplierPurchaseOrderList.vue?vue&type=script&lang=js&"
import style0 from "./SupplierPurchaseOrderList.vue?vue&type=style&index=0&id=4431a399&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4431a399",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VChip,VCol,VContainer,VDataTable,VIcon,VList,VListItem,VListItemSubtitle,VMenu,VRow})
